import React from 'react';

import './CustomButton.scss';

interface Props {
  text: string;
  width?: string | number;
  height?: string | number;
  backgroundColor?: string;
  marginTop?: string | number;
  marginRight?: string | number;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'submit' | 'reset' | 'button';
}

export const CustomButton = ({
  text,
  width,
  onClick,
  type,
  height,
  backgroundColor,
  disabled,
  marginTop,
  marginRight,
}: Props) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="custom-button"
      style={{ width, height, backgroundColor, marginTop, marginRight }}
    >
      {text}
    </button>
  );
};
